export default __webpack_public_path__ + "76748376679df0b0ce6ce578220affd9.svg";